export const JOB_CONFIG = {
  fixed: {
    title: "Create Fixed Job",
  },
  hourly: {
    title: "Create Hourly Job",
  },
  dedicated: {
    title: "Create Dedicated Job",
  },
  recurring: {
    title: "Create Recurring Job",
  },
  bucket:{
    title:"Create Bucket Job"
  },
  free: {
    title: "Create Free Job",
  },
};
